import { api } from "../axios";
import { Location } from "../_interface/location";

export async function getLocationById(locationId: number): Promise<Location> {
    const {data} = await api.get<Location>(`/location/${locationId}`); 
    return data;
}